import api from "@/plugins/api";
import { logger } from "@/infrastructure/services/LoggerService";
function mapItems(body) {
    const rawData = body?.data;
    const raw = Array.isArray(rawData)
        ? rawData
        : [];
    const items = raw.map((i) => ({ id: i.projectId, name: i.name, code: i.code }));
    const totalItems = typeof body?.pagination?.totalItems === "number" ? body.pagination.totalItems : items.length;
    return { items, totalItems };
}
/**
 * Searches OPROJ projects by name/code via the existing BFF route
 * GET /api/v1/portal/projects/search.
 *
 * @param q        Free-text query (name or code prefix).
 * @param page     1-based page number (default 1).
 * @param pageSize Results per page (default 20).
 * @param statuses Lifecycle statuses to keep; every status when omitted.
 */
export async function searchProjects(q, page = 1, pageSize = 20, statuses) {
    const response = await api.get(`/portal/projects/search`, {
        params: { q, page, pageSize, status: statuses },
        // CONSTRAINT: `status` is an array; axios' default spelling `status[]=A` is not bound by
        // ASP.NET Core, so the BFF would answer 200 and silently drop the filter (R61).
        paramsSerializer: { indexes: null },
    });
    return mapItems(response.data);
}
/**
 * Fetches EVERY page for a query (for "Select all" and the See-all modal).
 * Stops at `cap` results or `totalItems`, whichever comes first; warns if capped.
 *
 * @param q        Free-text query (name or code prefix).
 * @param cap      Maximum number of results to return (default 1000).
 * @param statuses Lifecycle statuses to keep; every status when omitted.
 */
export async function searchAllProjects(q, cap = 1000, statuses) {
    const pageSize = 100;
    const all = [];
    let total = 0;
    let page = 1;
    let hasMore = true;
    while (hasMore && all.length < cap) {
        const response = await api.get(`/portal/projects/search`, {
            params: { q, page, pageSize, status: statuses },
            // Same array-spelling constraint as `searchProjects` above.
            paramsSerializer: { indexes: null },
        });
        const mapped = mapItems(response.data);
        total = mapped.totalItems;
        all.push(...mapped.items);
        hasMore = mapped.items.length > 0 && all.length < total;
        page += 1;
    }
    if (total > cap) {
        logger.warn(`searchAllProjects: result set (${total}) exceeds cap (${cap}); selecting first ${cap} only.`);
    }
    return { items: all.slice(0, cap), totalItems: total };
}
